export default "__VITE_ASSET__D22A9VTj__"